module.exports = __webpack_public_path__ + "static/media/mikmak-gradient-logo-1.a7afee95.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/mikmak-gradient-logo-1.png
// module id = 173
// module chunks = 0